<template>
  <q-card v-if="catalogEntry" flat class="smallcard column no-wrap" :style="{height: height, width: width}">
    <q-card-section style="padding: 0" class="row no-wrap">
      <q-img
        :src="getImageUrl(catalogEntry.piece.image)"
        :ratio="1"
        style="border-radius: 4px"
        :style="{height: height, width: width}"
      >
        <div class="text-subtitle2 smallcard_textwrapper q-mt-sm text-black" style="background-color: rgba(255, 255, 255, 0.65); height: 40px">
          <p class="smallcard_text ellipsis" style="margin-left: auto; margin-right: auto; max-width: 90%">{{ catalogEntry.piece.title | capitalize }}</p>
          <p class="smallcard_text-smaller ellipsis" style="margin-left: auto; margin-right: auto; max-width: 90%">{{ isChallenge ? catalogEntry.title : catalogEntry.piece.artist }}</p>
        </div>
      </q-img>
      <score-indicator class="score-indicator absolute-full q-ma-md" :score="songScore" :score-diff="songScoreDiff" :absolute-bottom-right="true" />
    </q-card-section>
  </q-card>
</template>

<script>
import {Mixins} from "vue-property-decorator";
import CatalogEntryMixin from "src/modules/catalog/components/cards/CatalogEntryMixin";
import {getImageUrl} from 'src/utils/helpers';

export default class CatalogCardScoreEvolution extends Mixins(CatalogEntryMixin){
  getImageUrl = getImageUrl;

  height = '150px'
  width = '150px'
}
</script>

<style lang="scss" scoped>

.smallcard_textwrapper {
  display: flex;
  place-content: center;
  flex-direction: column;
  padding: 0;
  margin: 0;
  position: relative;
}

.smallcard_text {
  font-size: 0.9em;
  line-height: 1.2;
  padding: 0;
  margin: 0;
}

.smallcard_text-smaller {
  font-size: 0.7em;
  line-height: 1.2;
  padding: 0;
  margin: 0;
}
</style>
